export default __webpack_public_path__ + "static/media/greeting.42752463.webp";